import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
    import emitter from '@/utils/mitt';
    import GenericTHGTagTable from '@/components/thg/tags/GenericTHGTagTable.vue';
    import { THGTag } from '@/interfaces/thg/THGTag';
    import { fetchTHGTags } from '@/api/thg/tags';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGTagsList',
  setup(__props) {

    const data = ref<THGTag[]>();

    async function doDataFetching() {
        emitter.emit('showLoader');
        data.value = (await fetch()) as THGTag[];
        emitter.emit('hideLoader');
    }

    async function fetch() {
        const response = await fetchTHGTags();
        const tags = await response.parsedBody;

        if (!tags) {
            throw new Error('Error while getting thg tags.');
        }

        return tags;
    }

    onMounted(async () => {
        await doDataFetching();
    });

return { __sfc: true,data, doDataFetching, fetch, GenericTHGTagTable }
}

})